import { styled } from '@mui/material/styles';
import { Box, LinearProgress } from '@mui/material';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

export const HistoryIconBox = styled(Box)({
  width: '5%'
});

export const DateBox = styled(Box)({
  width: '15%'
});

export const VersionBox = styled(Box)({
  width: '10%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
});

export const PercentageBox = styled(Box)({
  width: '10%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
});

export const ProgressBox = styled(Box)({
  width: '40%'
});

export const StyledLinearProgress = styled(LinearProgress)({
  width: '100%'
});

export const TimeBox = styled(Box)({
  width: '25%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'
});

export const StyledAccessAlarmIcon = styled(AccessAlarmIcon)(({ theme }) => ({
  marginRight: theme.spacing(1)
}));

export const PointsBox = styled(Box)({
  width: '10%'
}); 